import type { CalendarEvent } from '@wtfalch/calendar/calendar';

import { parse, pathForChat, pathForMail } from '../routes.ts';

export type SourceThread = {
  kind: 'mail' | 'chat';
  title: string;
  path: string;
};

/** The mail thread or chat conversation of this agora that an event links
 *  back to, or `null`. Only a link that names this agora and a thread (or a
 *  chat room) counts: a link to another company's agora, a bare mailbox or any
 *  other address is not where the event came from. */
export function sourceThreadOf(
  event: Pick<CalendarEvent, 'links'>,
  agoraId: string,
): SourceThread | null {
  for (const link of event.links ?? []) {
    let pathname: string;
    try {
      pathname = new URL(link.href).pathname;
    } catch {
      continue;
    }
    const route = parse(pathname);
    if (route.kind !== 'agora' || route.agoraId !== agoraId) continue;
    if (route.section === 'mail' && route.location.threadId && route.location.mailboxId) {
      return {
        kind: 'mail',
        title: link.title?.trim() || 'A mail thread',
        path: pathForMail(agoraId, route.location),
      };
    }
    if (route.section === 'chat' && route.location.roomId) {
      return {
        kind: 'chat',
        title: link.title?.trim() || 'A chat conversation',
        path: pathForChat(agoraId, route.location),
      };
    }
  }
  return null;
}
